import React from 'react';
import { motion } from 'framer-motion';
export function Philosophy() {
  return <section id="about" className="py-16 md:py-24 bg-sep-offwhite" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-168">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="order-2 lg:order-1" data-id="element-169">
            <div className="w-16 h-1.5 bg-sep-red mb-6" data-id="element-170"></div>
            <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-sep-charcoal uppercase mb-6" data-id="element-171">
              OUR ELITE PHILOSOPHY
            </h2>
            <div className="space-y-6 text-gray-700 text-base md:text-lg" data-id="element-172">
              <p data-id="element-173">
                At Slater Elite Performance, we believe that true greatness is
                forged through discipline, mindset, and relentless effort. We
                don't just run drills; we build athletes.
              </p>
              <p data-id="element-174">
                Our mission is to combine elite basketball training, sports
                performance, fitness, and cognitive ball therapy to sharpen both
                body and mind. Whether you're a beginner learning the
                fundamentals or an advanced athlete preparing for the next
                level, our approach is tailored to push your limits.
              </p>
              <p className="font-bold text-sep-charcoal border-l-4 border-sep-red pl-4 italic" data-id="element-175">
                "We train the physical to perform, and the mental to prevail."
              </p>
            </div>
            <div className="mt-8" data-id="element-176">
              <a href="#services" className="inline-flex items-center font-bold text-sep-red hover:text-sep-red-dark transition-colors uppercase tracking-wide" data-id="element-177">
                Explore Our Services
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-178">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" data-id="element-179" />
                </svg>
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-1 lg:order-2 relative" data-id="element-180">
            <div className="aspect-[4/3] md:aspect-square lg:aspect-[4/5] rounded-lg overflow-hidden shadow-2xl relative" data-id="element-181">
              <div className="absolute inset-0 bg-sep-red/10 z-10 mix-blend-multiply" data-id="element-182"></div>
              <img src="https://cdn.magicpatterns.com/uploads/mjd7N55Xmi95F1yqnKKTsd/tyler-raye-Xb1d-N04Quc-unsplash.jpg" alt="Athlete Training" className="w-full h-full object-cover object-center grayscale-[20%]" data-id="element-183" />
              {/* Decorative elements */}
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-sep-red -z-10 rounded-lg" data-id="element-184"></div>
              <div className="absolute -top-4 -left-4 w-32 h-32 border-4 border-sep-charcoal/10 -z-10 rounded-lg" data-id="element-185"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}